export default __webpack_public_path__ + "static/scarf-52ac3385f5e400abc0514f8d680eaefd.png";